import React from 'react';
import { AlertTriangle, PhoneOff, Lock, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-14 bg-white" data-id="element-168">
      <div className="container mx-auto px-4" data-id="element-169">
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-171">
            La verdad incómoda
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-172">
            Si hoy te entra una llamada y tu cuerpo reacciona antes que tu
            cabeza… no es porque seas irresponsable.
            <span className="font-semibold text-slate-900" data-id="element-173">
              {' '}
              Es porque estás sin mapa.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 max-w-5xl mx-auto" data-id="element-174">
          {/* Pain Point 1 */}
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-175">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-176">
              <PhoneOff className="w-6 h-6 text-red-600" data-id="element-177" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-178">
              Evitas el teléfono
            </h3>
            <p className="text-slate-600" data-id="element-179">
              Sientes que la deuda te está cazando. Si contestas, te manipulan.
              Si no contestas, sientes que te van a destruir.
            </p>
          </div>

          {/* Pain Point 2 */}
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-180">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4" data-id="element-181">
              <AlertTriangle className="w-6 h-6 text-orange-600" data-id="element-182" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-183">
              Firmas por pánico
            </h3>
            <p className="text-slate-600" data-id="element-184">
              Para apagar el fuego hoy, aceptas cuotas imposibles o pides otro
              préstamo. Conviertes un incendio en incendio + gasolina.
            </p>
          </div>

          {/* Pain Point 3 */}
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-185">
            <div className="w-12 h-12 bg-slate-200 rounded-full flex items-center justify-center mb-4" data-id="element-186">
              <Lock className="w-6 h-6 text-slate-700" data-id="element-187" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-188">
              Vergüenza silenciosa
            </h3>
            <p className="text-slate-600" data-id="element-189">
              "Me da vergüenza… pero también rabia conmigo." No le cuentas a
              nadie y el problema crece en la oscuridad.
            </p>
          </div>

          {/* Pain Point 4 */}
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-190">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-191">
              <XCircle className="w-6 h-6 text-blue-600" data-id="element-192" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-193">
              Improvisación total
            </h3>
            <p className="text-slate-600" data-id="element-194">
              "Pago lo que alcance". Eso no es un plan, es supervivencia sin
              dirección. Te mantiene girando en círculos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}